// extracted by mini-css-extract-plugin
export default {"layout":"video_layout__17wFh"};